import { Component, OnInit } from "@angular/core";
import { ProjectsService } from "./projects.service";
import { Router } from "@angular/router";
import * as moment from "moment";

@Component({
  selector: "projects-component",
  template: require('./projects.component.html'),
  styles: [require('./projects.component.scss')]
})
export class ProjectsComponent implements OnInit {
  projects: any[];
  reverse: boolean;
  predicate: string = "created_at";
  itemsPerPageValues: number[];
  itemsPerPage: number = 10;
  getFieldOrderBy: Function;

  constructor(private service: ProjectsService, private router: Router) {
    // Do stuff
  }

  ngOnInit() {
    this.getProjects().subscribe((it) => {
      this.sortBy("it.created_at", "created_at");
    });
    this.itemsPerPageValues = this.service.getItemsPerPageValues();
    this.itemsPerPage = this.service.getItemsPerPage();
  }

  getProjects() {
    return this.service.getProjects().map((projects) => {
      this.projects = projects;
    });
  }

  sortBy(getField: string, fieldName: string) {
    this.reverse = !this.reverse;
    this.reverse = this.predicate === fieldName ? this.reverse : false;
    this.predicate = fieldName;
    this.getFieldOrderBy = new Function(
      "it",
      `return (${getField} || '').toString().toLowerCase();`
    );
  }

  formatDate(date: any) {
    return moment(date).format("DD/MM/YYYY hh:mm A");
  }

  editProject(project: any) {
    ProjectsService.currentProject = project;
    this.router.navigate(["/editproject"]);
  }

  onChangeItemsPerPage(value) {
    this.service.saveItemsPerPage(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/projects/projects.component.ts